import React, { memo, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';

/** Same rotating hints as Homepage2026 - shared across app header */
export const DEFAULT_HOME_SEARCH_PHRASES = [
  'premium stag-friendly places',
  'solo-friendly bars and pubs',
  'places where stags are welcome',
  'know minimum order and where to sit',
  'find plug points and Wi-Fi for work',
  'see minimum order before you go',
  'find solo women-friendly places',
  'know where to sit and what to expect',
];

/**
 * Search strip: icon + rotating phrase. When interactive, tap navigates to venue discovery.
 */
const PhraseRotator = memo(function PhraseRotator({
  phrases = DEFAULT_HOME_SEARCH_PHRASES,
  interactive = true,
  navigateTo = '/stag-venues',
}) {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const id = window.setInterval(() => {
      setIndex((p) => (p + 1) % phrases.length);
    }, 2600);
    return () => window.clearInterval(id);
  }, [phrases.length]);

  const handleSearchClick = () => {
    if (interactive) {
      navigate(navigateTo);
    }
  };

  const handleMascotClick = (e) => {
    e.stopPropagation();
    window.dispatchEvent(new CustomEvent('openAskStagster'));
  };

  return (
    <div className="mt-2 flex min-h-[2.5rem] items-center justify-between gap-3 rounded-[16px] bg-white/[0.03] px-3.5 py-1.5 shadow-[inset_0_0_0_1px_rgba(255,255,255,0.04)] hover:bg-white/[0.05] transition-colors">
      <div 
        onClick={handleSearchClick}
        className={`flex items-center gap-3 flex-1 min-w-0 ${interactive ? "cursor-pointer" : ""}`}
      >
        <Search className="h-3.5 w-3.5 shrink-0 text-white/20" strokeWidth={1.8} />
        <div className="relative h-4 min-h-[1rem] min-w-0 flex-1 overflow-hidden">
          {phrases.map((phrase, i) => (
            <span
              key={phrase}
              className={`absolute inset-0 flex items-center text-[11px] tracking-[0.01em] transition-all duration-500 ease-out ${
                i === index
                  ? 'translate-y-0 opacity-100'
                  : i === (index - 1 + phrases.length) % phrases.length
                    ? '-translate-y-3 opacity-0'
                    : 'translate-y-3 opacity-0'
              }`}
              style={{ color: 'rgba(255,255,255,0.38)' }}
            >
              {phrase}
            </span>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={handleMascotClick}
        className="flex items-center justify-center p-1 rounded-lg hover:bg-white/10 active:scale-90 transition shrink-0"
        title="Ask STAGSTER Bot"
      >
        <img
          src="/logo-mascot.webp"
          alt="Mascot"
          className="h-5 w-5 object-contain filter drop-shadow-[0_0_8px_rgba(244,63,94,0.55)] hover:drop-shadow-[0_0_12px_rgba(244,63,94,0.85)] transition-all duration-300"
        />
      </button>
    </div>
  );
});

export default PhraseRotator;
